import { bi, type Bilingual } from './types';

/**
 * kintai 従業員 PWA の全文字列 (JP/VN 併記)。
 * 片方の言語が欠ける場合は TypeScript の型でエラーになる。
 *
 * ベトナム語訳は機械翻訳ベース。リリース前にネイティブ監修推奨。
 */
export const dict = {
  appTitle: bi('kintai 打刻', 'Chấm công'),

  // SelectName
  selectName: bi('名前を選んでください', 'Chọn tên của bạn'),
  noEmployees: bi('従業員データがありません', 'Không có dữ liệu nhân viên'),

  // PinEntry
  enterPin: bi('PIN を入力', 'Nhập mật khẩu'),
  pinHint: bi('4 桁の暗証番号', 'Mật khẩu 4 chữ số'),
  pinWrong: bi('PIN が違います', 'Mật khẩu không đúng'),
  pinLocked: bi('ロックされました (5分後に再試行)', 'Đã bị khóa (thử lại sau 5 phút)'),
  remainingAttempts: bi('残り試行回数', 'Số lần thử còn lại'),
  back: bi('戻る', 'Quay lại'),

  // Punch
  selectSite: bi('現場 / Hiện trường', 'Hiện trường'),
  punchIn: bi('出勤', 'Bắt đầu làm việc'),
  punchOut: bi('退勤', 'Kết thúc làm việc'),
  todayPunches: bi('今日の打刻', 'Chấm công hôm nay'),
  noPunchesToday: bi('まだ打刻がありません', 'Chưa chấm công hôm nay'),
  clockOutReminder: bi(
    '退勤打刻がまだです。仕事が終わったら必ず「退勤」を押してください',
    'Bạn chưa chấm công kết thúc. Khi xong việc hãy nhấn「Kết thúc làm việc」',
  ),
  punchedAtIn: bi('出勤', 'Bắt đầu'),
  punchedAtOut: bi('退勤', 'Kết thúc'),

  // PunchSuccess
  punchedInSuccess: bi('出勤しました', 'Đã bắt đầu làm việc'),
  punchedOutSuccess: bi('退勤しました', 'Đã kết thúc làm việc'),
  goHome: bi('ホームに戻る', 'Trang chủ'),

  // Common
  loading: bi('読み込み中...', 'Đang tải...'),
  error: bi('エラー', 'Lỗi'),
  retry: bi('もう一度', 'Thử lại'),
  logout: bi('ログアウト', 'Đăng xuất'),
  alreadyPunchedIn: bi('既に出勤済みです', 'Đã bắt đầu làm việc'),
  alreadyPunchedOut: bi('既に退勤済みです', 'Đã kết thúc làm việc'),
  networkError: bi('通信エラー', 'Lỗi kết nối'),

  // Footer
  takeCare: bi('お疲れさまでした', 'Cảm ơn vì đã làm việc'),

  // SelectName 検索
  searchPlaceholder: bi(
    '名前で検索 (ローマ字でも可)',
    'Tìm kiếm theo tên (có thể nhập bằng chữ La-tinh)',
  ),
  noMatch: bi('該当する従業員が見つかりません', 'Không tìm thấy nhân viên phù hợp'),

  // ChangePin
  changePinTitle: bi('PIN を変更', 'Đổi mật khẩu'),
  initialChangePinTitle: bi(
    '初回ログイン — PIN を変更してください',
    'Lần đầu đăng nhập — Vui lòng đổi mật khẩu',
  ),
  currentPinLabel: bi('現在のPIN', 'Mật khẩu hiện tại'),
  newPinLabel: bi('新しいPIN (4〜8桁)', 'Mật khẩu mới (4–8 chữ số)'),
  confirmPinLabel: bi('新しいPIN (確認)', 'Xác nhận mật khẩu mới'),
  changePinSubmit: bi('PINを変更する', 'Đổi mật khẩu'),
  pinChanged: bi('PINを変更しました', 'Đã đổi mật khẩu'),
  pinMismatch: bi('新しいPINが一致しません', 'Mật khẩu mới không khớp'),
  pinSameAsCurrent: bi(
    '新しいPINは現在と異なるものにしてください',
    'Mật khẩu mới phải khác với mật khẩu hiện tại',
  ),
  pinInvalid: bi('PINは4〜8桁の数字です', 'Mật khẩu phải là 4–8 chữ số'),

  // Punch メニュー
  menuChangePin: bi('PINを変更', 'Đổi mật khẩu'),
} as const satisfies Record<string, Bilingual>;

export type DictKey = keyof typeof dict;
